import { CustomFieldSettingsValidation } from '@/components/Fields/dataObjects/CustomFieldSettingsValidation'

import { CustomFieldSettingsFragment, CustomFieldSettingsInput } from '@/gql/graphql'

export class CustomFieldSettings {
  validation: CustomFieldSettingsValidation

  constructor(settings: Partial<CustomFieldSettingsFragment> = { validation: [] }) {
    this.validation = new CustomFieldSettingsValidation(settings?.validation || [])
  }

  public toGraphQLInput(): CustomFieldSettingsInput {
    return {
      validation: this.validation.toGraphQLInput(),
    }
  }
}
